import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = { pollUrl: String }

  connect() {
    this.pollInterval = setInterval(() => this.checkStatus(), 5_000)
  }

  disconnect() {
    if (this.pollInterval) clearInterval(this.pollInterval)
  }

  async checkStatus() {
    try {
      const response = await fetch(this.pollUrlValue, {
        headers: { "Accept": "text/html" }
      })
      const html = await response.text()

      // If the response contains the iframe, the instance is ready
      if (html.includes('data-creator-status-value="running"')) {
        clearInterval(this.pollInterval)
        window.location.reload()
      }

      // If it failed, reload to show error
      if (html.includes("Editor failed to start")) {
        clearInterval(this.pollInterval)
        window.location.reload()
      }

      // If the instance is gone (terminated), the server redirects to /creator/new
      if (html.includes('data-creator-state="new"')) {
        clearInterval(this.pollInterval)
        window.location.reload()
      }
    } catch (error) {
      console.warn("Status check failed:", error)
    }
  }
}
